/**
 * For more information on the flows, please refer to the following documentation:
 * For more information see: https://workivate.atlassian.net/wiki/spaces/WT/pages/5550243882/USL+Login+Flows
 */
export enum FLOW {
  WAM_SUBDOMAIN = 'WAM_SUBDOMAIN',
  X_USL_OTT = 'X_USL_OTT',
  USERTOKEN_AND_OTT = 'USERTOKEN_AND_OTT',
  USERTOKEN = 'USERTOKEN',
  USL_AUTH = 'USL_AUTH',
  AUTH_PARAMS = 'AUTH_PARAMS',
  AUTH_CHECK = 'AUTH_CHECK',
  AUTHENTICATED_REDIRECT_NEEDED = 'AUTHENTICATED_REDIRECT_NEEDED',
  AUTHENTICATED_NO_REDIRECT_NEEDED = 'AUTHENTICATED_NO_REDIRECT_NEEDED',
  AUTHENTICATED_SHOULD_NOT_REDIRECT = 'AUTHENTICATED_SHOULD_NOT_REDIRECT',
  NOT_AUTHENTICATED = 'NOT_AUTHENTICATED',
}
